import { getMappedLogsForJob, restartJob, stopJob } from "@/Services/Ressources/API/JobService";
import { withNotification } from "@/Modules/utils/withNotification";
import { iconNames } from "@/Modules/utils/icons";

const jobDetails = async (row) => {
  const response = await getMappedLogsForJob(row.Tenant, row.Jobkey, row.organizationUnitId)
}

const start = withNotification(async (row) => {
  console.log(row)
  return await restartJob(row.Nummer, row.organizationUnitId);
}, {
  successTitle: "Job Started",
  successMessage: "The job was started successfully.",
  errorTitle: "Start Failed",
  fallbackErrorMessage: "An unexpected error occurred while starting the job."
});

const stop = withNotification(async (row) => {
  return await stopJob(row.Nummer, row.organizationUnitId);
}, {
  successTitle: "Job Stopped",
  successMessage: "The job was stopped successfully.",
  errorTitle: "Stop Failed",
  fallbackErrorMessage: "An unexpected error occurred while stopping the job."
});

export const actions = [
  {
    type: "row-click",
    handler: jobDetails
  },
  {
    label: "Start",
    icon: iconNames.play,
    variant: "success",
    tooltip: "Start Job",
    handler: start,
  },
  {
    label: "Stop",
    icon: iconNames.stop,
    variant: "danger",
    tooltip: "Stop Job",
    handler: stop,
  },
];